import { HTMLAttributes } from 'react'

import { cn } from '../../lib/utils'

type CornerBracketsProps = HTMLAttributes<HTMLDivElement> & {
  size?: number
  strokeWidth?: number
}

export function CornerBrackets({
  className,
  size = 12,
  strokeWidth = 2,
  ...props
}: CornerBracketsProps) {
  const s = `${size}px`
  const sw = `${strokeWidth}px`

  return (
    <div className={cn('pointer-events-none absolute inset-0', className)} {...props}>
      <span
        className="absolute left-0 top-0 border-kinetic-primary-container"
        style={{ width: s, height: s, borderLeftWidth: sw, borderTopWidth: sw }}
      />
      <span
        className="absolute right-0 top-0 border-kinetic-primary-container"
        style={{ width: s, height: s, borderRightWidth: sw, borderTopWidth: sw }}
      />
      <span
        className="absolute bottom-0 left-0 border-kinetic-primary-container"
        style={{ width: s, height: s, borderLeftWidth: sw, borderBottomWidth: sw }}
      />
      <span
        className="absolute bottom-0 right-0 border-kinetic-primary-container"
        style={{ width: s, height: s, borderRightWidth: sw, borderBottomWidth: sw }}
      />
    </div>
  )
}
